var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-sidebar__content search__document"},[_c('h1',{staticClass:"home__title"},[_vm._v("\n      О документе\n    ")]),_c('document-info',{attrs:{"card":_vm.currentDocumentInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }